module.exports = __webpack_public_path__ + "img/twism-logo-white.f68afa0a.svg";